import { render, staticRenderFns } from "./ActorList.vue?vue&type=template&id=4d6a174a&scoped=true"
import script from "./ActorList.vue?vue&type=script&lang=js"
export * from "./ActorList.vue?vue&type=script&lang=js"
import style0 from "./ActorList.vue?vue&type=style&index=0&id=4d6a174a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d6a174a",
  null
  
)

export default component.exports